module.exports = __webpack_public_path__ + "static/img/10.4574b39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/10.png
// module id = BP7X
// module chunks = 0